<template>
    <div>

        <!-- Footer -->
        <footer id="footer">
            <div class="copy">Copyright &copy; SiteEngine Inc. All Rights Reserved.</div>
        </footer>

    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        created() {},
        methods: {},
    }
</script>
